var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar component",class:("size-" + _vm.size)},[_c('UiImgLoader',{attrs:{"src":_vm.avatar,"alt":_vm.alt,"animated":_vm.animated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }